/* eslint-disable */
import type { CashInstrumentType } from "../../../franklin/cash_instrument_type.pb";
import type { ProcessingMode } from "../../moneta/core/models.pb";

export interface InstrumentSelectionOption {
  new_link?: NewLinkSelectionOption | undefined;
  replace_link?: ReplaceLinkSelectionOption | undefined;
  existing_link?: ExistingLinkSelectionOption | undefined;
  digital_wallet?: DigitalWalletSelectionOption | undefined;
}

export interface NewLinkSelectionOption {
  instrument_type?: CashInstrumentType;
}

export interface ReplaceLinkSelectionOption {
  instrument_type?: CashInstrumentType;
  instrument_token?: string;
}

export interface ExistingLinkSelectionOption {
  instrument_type?: CashInstrumentType;
  instrument_token?: string;
  /**
   * The selected option may contain more than one instrument. For example, we sometimes
   * consolidate the debit card & bank account options if they belong to the same bank.
   */
  options?: ExistingLinkSelectionOptionInstrumentOption[];
  processing_mode?: ProcessingMode;
  is_consolidated?: boolean;
}

export interface ExistingLinkSelectionOptionInstrumentOption {
  instrument_type?: CashInstrumentType;
  instrument_token?: string;
}

export interface DigitalWalletSelectionOption {
  type?: DigitalWalletSelectionOptionType;
  apple_pay_payload?:
    | DigitalWalletSelectionOptionApplePayPayload
    | undefined;
  /**
   * Used in requirement handling to send back the created Lynx instrument.
   * Required for digital wallet flows (ex. Apple Pay)
   */
  instrument_link?: DigitalWalletSelectionOptionInstrumentLink;
}

export enum DigitalWalletSelectionOptionType {
  APPLE_PAY = "APPLE_PAY",
}

export interface DigitalWalletSelectionOptionApplePayPayload {
  data?: string;
  header?: DigitalWalletSelectionOptionApplePayPayloadHeader;
  signature?: string;
  version?: string;
}

export interface DigitalWalletSelectionOptionApplePayPayloadHeader {
  application_data?: string;
  ephemeral_public_key?: string;
  wrapped_key?: string;
  public_key_hash?: string;
  transaction_id?: string;
}

export interface DigitalWalletSelectionOptionInstrumentLink {
  finplat_instrument_token?: string;
  instrument_type?: CashInstrumentType;
  owner_token?: string;
}
